import { useState, useContext } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup";

import Link from '@/components/Link'
import { LockClosedIcon } from '@heroicons/react/solid'
import { AuthContext } from '@/contexts/AuthContext'
import { ModalContext } from '@/contexts/ModalContext'
import SocialRegister from '@/components/SocialRegister'
import modalRoutes from '@/modalRoutes'
import Button from '@/components/Button'
import resolveErrors from '../../utils/resolveErrors';

export default function LoginPanel() {
  const { login } = useContext(AuthContext)
  const { closeModal } = useContext(ModalContext)
  const [serverErrors, setServerErrors] = useState(null)

  const schema = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().min(6).max(32).required(),
  });

  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = async (data) => {
    try {
      await login(data.email, data.password)
      closeModal()
    } catch (err) {
      setServerErrors(resolveErrors(err))
    }
  }

  return (
    <>
      <div className="text-sm text-center pt-4">
        <p>Always ensure you are visiting the correct url</p>
        <p className="flex items-center justify-center mt-2"><LockClosedIcon className="w-4 h-4 mr-1" />{window.location.origin}</p>
      </div>
      <form onSubmit={handleSubmit(onSubmitHandler)} className="mt-6 grid gap-4 text-sm">
        <div>
          <label className="block mb-1 font-medium">Email</label>
          <input {...register('email')} placeholder="Email" type="email" required className={errors?.email ? '!border-red-500' : ''} />
        </div>
        <div>
          <label className="block mb-1 font-medium">Password</label>
          <input {...register('password')} placeholder="*****" type="password" required className={errors.password ? '!border-red-500' : ''} />
        </div>
        {serverErrors && <p className="text-xs text-red-500 font-medium">{serverErrors}</p>}
        <Button modifier="primary" type="submit" className="py-3">
          {isSubmitting ? (
            <span className="flex items-center justify-center">
              Submitting
              <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
          ) : (
            <span>Sign In</span>
          )}
        </Button>
      </form>
      <div className="mt-4 grid gap-5">
        {/* <p className="text-sm text-center">Or continue with</p> */}
        {/* <SocialRegister google dark /> */}
        <Link to={modalRoutes.FORGOT_PASSWORD} className="block mx-auto font-medium text-white text-sm">
          <span>Forgot Password</span>
        </Link>
        <p className="text-xs text-center">This site is protected by hCaptcha and the hCaptcha Privacy Policy and Terms of Service apply.</p>
      </div>
    </>
  )
}